import { svgIconClassName } from '@archipro-design/icons';
import { pxToRem, buttonClassName } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

import {
    PRODUCT_GALLERY_SIZE,
    PRODUCT_THUMB_SIZE,
} from './ProductGallery.style';

export const ThumbsContainer: StyleRule = ({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    width: pxToRem(PRODUCT_GALLERY_SIZE),

    [`& .${buttonClassName}`]: {
        position: 'absolute',
        top: '45%',
        height: pxToRem(PRODUCT_THUMB_SIZE),
        width: pxToRem(PRODUCT_THUMB_SIZE),
        marginTop: pxToRem(6),
        [`& span .${svgIconClassName}`]: {
            width: pxToRem(52),
            height: pxToRem(52),
        },
    },
    [theme.screen.tablet]: {
        marginTop: pxToRem(6),
    },
});

export const ThumbList: StyleRule<{
    THUMB_WIDTH: number;
    slideCount: number;
    showPrevBtn: boolean;
    showNextBtn: boolean;
    swipeInitialised: boolean;
}> = ({
    THUMB_WIDTH,
    slideCount,
    showPrevBtn,
    showNextBtn,
    swipeInitialised,
}) => {
    const MAX_SLIDES = slideCount === 6 ? 6 : 5;
    const slidesDisplayed =
        showPrevBtn && showNextBtn ? MAX_SLIDES - 1 : MAX_SLIDES;
    return {
        position: 'relative',
        width: pxToRem(THUMB_WIDTH * slidesDisplayed),
        left: showPrevBtn ? pxToRem(THUMB_WIDTH) : 0,
        overflow: 'hidden',
        transition: swipeInitialised ? '0.3s ease-in-out' : 'none',
    };
};

export const ThumbSlider: StyleRule<{
    translateWidth: number;
    swipeInitialised: boolean;
}> = ({ translateWidth, swipeInitialised }) => {
    return {
        marginTop: 0,
        padding: 0,
        transform: `translate3d(${pxToRem(translateWidth)}, 0, 0) !important`,
        transition: swipeInitialised ? 'transform 0.4s ease-in-out' : 'none',
    };
};

export const LeftNavBtn: StyleRule<{
    showPrevBtn: boolean;
    swipeInitialised: boolean;
}> = ({ showPrevBtn, swipeInitialised }) => ({
    left: showPrevBtn ? pxToRem(PRODUCT_THUMB_SIZE) : 0,
    transition: swipeInitialised ? '0.4s' : ' none',
    transform: 'translate(-100%, -50%)',
});

export const RightNavBtn: StyleRule<{
    showNextBtn: boolean;
    swipeInitialised: boolean;
}> = ({ showNextBtn, swipeInitialised }) => ({
    right: showNextBtn ? pxToRem(PRODUCT_THUMB_SIZE) : 0,
    transform: 'translate(100%, -50%)',
    transition: swipeInitialised ? '0.4s' : 'none',
});
